import Vue from 'vue'
import ut from '@/utils'

import {Resource} from 'vue-resource'

const Group = {
  id: null,
  name: '',
}

const Colors = ['warning', 'success', 'error', 'accent']

const GroupResource = new Resource('/', {}, {
  list: {
    method: 'GET',
    url: 'common/group/list/',
  },
  details: {
    method: 'GET',
    url: 'common/group/detail/{id}/',
  },
  create: {
    method: 'POST',
    url: 'common/group/create/',
  },
  update: {
    method: 'PUT',
    url: 'common/group/update/{id}/',
  },
  remove: {
    method: 'DELETE',
    url: 'common/group/delete/{id}/',
  },
})

export default {
  namespaced: true,

  state: {
    data: null,

    fetching: false,
    model: ut.deepClone(Group),
    saving: false,
    deleting: {},
  },

  getters: {
    getGroup: (state) => (id) => state.data?.results?.find(m => m.id === id),
    getColor: (state) => (id) => Colors[id % Colors.length]
  },

  mutations: {
    setItems(state, data) {
      state.data = data
    },

    setModel(state, data) {
      state.model = {...ut.deepClone(Group), ...data}
    },
  },

  actions: {
    fetch({state, commit}, filters = {}) {
      filters.limit = filters.limit || 1000

      if (!state.fetching) {
        commit('setItems', null)
        state.fetching = GroupResource.list(ut.objFilter(filters))
          .then((response) => {
            commit('setItems', response.body)
          })
          .finally(() => state.fetching = false)
      }

      return state.fetching
    },

    show({state, commit}, id) {
      if (!state.fetching) {
        commit('setModel', {})
        state.fetching = GroupResource.details({id})
          .then(({body}) => {
            commit('setModel', body)
          })
          .finally(() => state.fetching = false)
      }

      return state.fetching
    },

    save({state, commit}) {
      state.saving = true
      let promise
      if (state.model.id) {
        promise = GroupResource.update({id: state.model.id}, state.model)
      } else {
        promise = GroupResource.create(state.model)
      }

      return promise
        .then(({body}) => {
          commit('setModel', body)
        })
        .finally(() => state.saving = false)
    },

    remove({state, dispatch}, id) {
      Vue.set(state.deleting, id, true)
      return GroupResource.remove({id})
        .then(() => dispatch('fetch'))
        .finally(() => Vue.set(state.deleting, id, false))
    },
  },
}
